import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../../components/shared/AuthContext';
import { useTeamContext } from '../../context/TeamContext';

export default function TeamInviteAcceptPage() {
  const { token } = useParams();
  const { apiClient } = useContext(AuthContext);
  const { refresh } = useTeamContext();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        await apiClient.post(`/api/organizations/invitations/${token}/accept`);
        await refresh();
        navigate('/teams');
      } catch (e) {
        setError(e.response?.data?.message || e.response?.data?.detail || 'Could not accept invitation.');
      }
    })();
  }, [apiClient, token, refresh, navigate]);

  if (error) return <div className="teams-error">{error}</div>;
  return <p className="teams-sub">Joining team…</p>;
}
